<template>
  <PForm
    v-model="validado"
    @cancel="limpiar"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('action.limpiar')"
  >
    <template>
      <PRow>
        <PCol md="12">
          <PFormSelect
            v-model="valueLocal.tipoFechaSelected"
            :options="tiposFecha"
            optionValue="key"
            optionText="value"
            :label="$t('label.tipoFecha')"
            :placeholder="$t('option.select')"
          />
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaInicio"
            :label="$t('label.fechaInicio')"
            :endSelector="valueLocal.fechaFin"
            :language="locale"
            :utcDate="true"
          />
        </PCol>
        <PCol md="12">
          <PFormDatepicker
            v-model="valueLocal.fechaFin"
            :label="$t('label.fechaFin')"
            :startSelector="valueLocal.fechaInicio"
            :maxToday="true"
            :maxRangeMonth="maxRange"
            :language="locale"
            :utcDate="true"
          />
        </PCol>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.delegationsSelected"
            :options="delegations"
            optionValue="id"
            optionText="desDelegacion"
            :label="$t('label.delegaciones')"
            :placeholder="$t('option.select')"
            :readonly="!clienteSelected?.id"
          />
        </PCol>
        <PCol md="12">
          <PFormSelectMulti
            v-model="valueLocal.puntosSelected"
            :options="puntos"
            optionValue="id"
            optionText="desPuntoservicio"
            :label="$t('label.puntoServicio')"
            :placeholder="$t('option.select')"
            :readonly="puntos.length === 0"
          />
        </PCol>
      </PRow>
    </template>
  </PForm>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import {
  ICliente,
  IClientexdel,
  IDelegacion,
  IPuntoServicio,
  IUsuario,
  KeyValuePair,
} from "@/entities";
import VueMethods from "@/vue-methods";
import { MAX_RANGE_MONTH_DATE } from "@/constans";

@Component({
  mixins: [VueMethods],
})
export class SaldosEntradasFiltersForm extends Vue {
  @Prop({ required: true }) value!: any;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = structuredClone(this.value);
    this.$set(
      this.valueLocal,
      "fechaInicio",
      this.valueLocal.fechaInicio
        ? new Date(this.valueLocal.fechaInicio!).toISOString()
        : this.getStartLocalDate(new Date().toISOString())
    );
    this.$set(
      this.valueLocal,
      "fechaFin",
      this.valueLocal.fechaFin
        ? new Date(this.valueLocal.fechaFin!).toISOString()
        : this.getEndLocalDate(new Date().toISOString())
    );
  }
  tiposFecha: KeyValuePair[] = [
    {
      key: "CONTABLE",
      value: this.$t("label.fecContable"),
    },
    {
      key: "SERVICIO",
      value: this.$t("label.fecServicio"),
    },
    {
      key: "MOVIMIENTO",
      value: this.$t("label.fecMovimiento"),
    },
  ];
  valueLocal: any = {
    tipoFechaSelected: this.tiposFecha[0].key,
    fechaInicio: this.getStartLocalDate(new Date().toISOString()),
    fechaFin: this.getEndLocalDate(new Date().toISOString()),
    delegationsSelected: [],
    puntosSelected: [],
  };
  initialValueLocal: any = {
    tipoFechaSelected: this.tiposFecha[0].key,
    fechaInicio: this.getStartLocalDate(new Date().toISOString()),
    fechaFin: this.getEndLocalDate(new Date().toISOString()),
    delegationsSelected: [],
    puntosSelected: [],
  };
  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Getter("getLocale") locale!: Locale;
  @Getter("getLoggedUser") getLoggedUser!: IUsuario;
  @Getter("getClienteSelected") clienteSelected: ICliente | undefined;
  public delegations: IDelegacion[] = [];
  validado = false;
  maxRange = MAX_RANGE_MONTH_DATE;

  mounted(): void {
    this.getDelegaciones();
  }
  private static readonly SORTBY_DELEGATIONS: string = "desDelegacion";

  async getDelegaciones(): Promise<void> {
    this.clienteSelected?.clientexdels.forEach((clientexdel) => {
      if (clientexdel.active) this.delegations.push(clientexdel.delegacion);
    });
    this.delegations.sort((a, b) =>
      this.sortAscending(a, b, SaldosEntradasFiltersForm.SORTBY_DELEGATIONS)
    );
  }

  get puntos(): IPuntoServicio[] {
    if (!this.clienteSelected) {
      return [];
    }

    const puntos: IPuntoServicio[] = [];

    let cxds = this.clienteSelected.clientexdels;

    if (this.valueLocal.delegationsSelected?.length) {
      cxds = cxds?.filter((cxd: IClientexdel) =>
        this.valueLocal.delegationsSelected.includes(cxd.delegacion?.id)
      );
    }
    cxds?.forEach((cxd) => puntos.push(...(cxd.puntosservicio || [])));

    return puntos;
  }

  @Watch("puntos", { immediate: true })
  onPuntosChanged(newPuntos: IPuntoServicio[]): void {
    const selected = (this.valueLocal.puntosSelected || []) as number[];
    if (!selected.length) return;

    const validIds = new Set<number>((newPuntos || []).map((p) => p.id));
    const nextSelected = selected.filter((id) => validIds.has(id));

    if (nextSelected.length !== selected.length) {
      this.$set(this.valueLocal, "puntosSelected", nextSelected);
    }
  }

  limpiar(): void {
    this.valueLocal.tipoFechaSelected = this.tiposFecha[0].key;
    this.valueLocal.fechaInicio = this.getStartLocalDate(new Date().toISOString());
    this.valueLocal.fechaFin = this.getEndLocalDate(new Date().toISOString());
    this.valueLocal.delegationsSelected = [];
    this.valueLocal.puntosSelected = [];
    if (!this.isInitialObject(this.value, this.initialValueLocal)) {
      this.$emit("input", this.valueLocal);
      this.$emit("cancel", { action: "clean" });
    }
  }
  action(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { data: this.valueLocal, action: action });
  }
}
export default SaldosEntradasFiltersForm;
</script>
